//在此处编写调用授权等基本平台接口
class oc_api {
	constructor(axiosFactory) {
		this.$http = axiosFactory;
	}
	http() {
		return this.$http;
	}
	get(url, cb) {
		this.$http.get(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});;
	}
	gets(url, data, cb) {
		this.$http.get(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	post(url, data, cb) {
		this.$http.post(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	posts(url, cb) {
		this.$http.post(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	put(url, data, cb) {
		this.$http.put(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	puts(url, cb) {
		this.$http.put(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	delete(url, data, cb) {
		this.$http.delete(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	deletes(url, cb) {
		this.$http.delete(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}

	//先判定本地是否存储，如果没有能够获取到本地存储，再次从远程获取；
	//name存储字段，url请求地址，cb回调函数
	getStorageData(name, url, cb) {
		var myObj = JSON.parse(localStorage.getItem(name));
		if (myObj) {
			cb(myObj);
		} else {
			this.$http.get(url).then(data => {
				cb(data.data);
				localStorage.setItem(name, JSON.stringify(data.data));
			});
		}
	}
	// ------------------------------------------------------------------------------------
	//判断职位是否关闭
	getMyOperation(positionId, cb) {
		this.get(`/position/${positionId}/operation`, cb)
  }
  //判断职位是否关闭,企业直招
  getCompanyMyOperation(positionId, cb) {
    this.get(`/position/${positionId}/operation`, cb)
  }
	//投递（随机推荐职位）
	getRecommendsPosition(pageSize, cb) {
		this.get("/applicant/expect/recommend/positions?pageNum=1&pageSize=" + pageSize, cb);
	}
	//获取职位
	getPostPositions(pageNum, data, cb) {
		this.post("/positions/search?pageSize=15&pageNum=" + pageNum, data, cb);
	}
	//职位详情举报--举报
	postReporthr(positionId, mm, cb) {
		this.post("/applicant/" + positionId + "/report", mm, cb);
	}
	//招聘专场，上海
	getPosition(cb) {
		this.get(`/positions/active?workPlaceCode=310000&salaryMin=30&pageNum=1&pageSize=9`, cb);
	}
	//招聘专场，杭州
	getHzPosition(code, cb) {
		this.get(`/positions/active?workPlaceCode=330100&functionCode=${code}&pageNum=1&pageSize=6`, cb);
	}
	//招聘专场，北京  industryCode
	getBjPosition(code, cb) {
		this.get(`/positions/active?workPlaceCode=110000&salaryMin=30&industryCode=${code}&pageNum=1&pageSize=5`, cb);
	}
	//招聘专场，420100武汉
	getWhPosition(code, cb) {
		this.get(`/positions/active?workPlaceCode=420100&salaryMin=30&industryCode=${code}&pageNum=1&pageSize=5`, cb);
	}
	//招聘专场，深圳
	getSzPosition(cb) {
		this.get(`/positions/active?workPlaceCode=440300&salaryMin=30&pageNum=1&pageSize=9`, cb);
	}
	//招聘专场，广州
	getGzPosition(code, cb) {
		this.get(`/positions/active?workPlaceCode=440100&degree=${code}&pageNum=1&pageSize=6`, cb);
	}
	//获取综合匹配度
  getMatchdegree(positionId,cb){
	  this.get(`/applicat/${positionId}/matchDegree/count`,cb)
  }
  //看了该职位的又看了其他职位
  getSeeOtherPosition(positionId,cb){
	  this.get(`applicat/otherPostion/see/${positionId}`,cb)
  }
  //获取职位的浏览记录
  getBrowsingHistory(pageNum,cb){
	  this.get(`/applicant/position/preview?pageSize=15&pageNum=` + pageNum,cb)
  }
  //获取热招职位
  getEnterprisePublishPosition(userName,pageNum,cb){
    this.get(`/applicant/publish/position?userName=${userName}&pageNum=${pageNum}&pageSize=10`,cb)
  }
  //面试邀请根据positionId查positionName
  getInterviewPositionIdName(interpositionId,cb){
    this.get(`/hr/positionName/${interpositionId}`,cb)
  }
}
class apiFactory {
	constructor() {

	}
	createApi(axios) {
		return new oc_api(axios)
	}
}
export default new apiFactory();
